<template>
  <div class="chart-3 d-flex align-center justify-center" v-resize="onResize">
    <Loader v-if="loading"></Loader>
    <div v-else id="chart-3"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import API from '@/service'
import Loader from '@/components/UI/Loader'
export default {
  components: {
    Loader
  },
  data: () => ({
    loading: true,
    chart: null,
    option: {
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        name: '月份',
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        name: '定标项目数量',
        type: 'value'
      },
      series: [{
        name: '定标项目数量',
        type: 'line',
        smooth: true,
        data: []
      }]
    }
  }),
  async mounted () {
    try {
      const res = await API.getEvalMonthDecisions()
      // console.log(res)
      this.option.xAxis.data = res.data.map(item => item.yearmonth)
      this.option.series[0].data = res.data.map(item => item.monthDealProjectNum)
    } catch (error) {
      console.log(error)
    }
    this.loading = false
    this.$nextTick(() => {
      this.chart = echarts.init(document.getElementById('chart-3'))
      this.chart.setOption(this.option)
    })
  },
  methods: {
    onResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-3 #chart-3 {
  width: 100%;
  height: 400px;
}
</style>
